(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('MeanwhileConfig')?.textContent || '{}');
  const text = config.text || {};
  const root = config.root || '/';
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: config.currency || 'USD' }).format(Number(value) / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const products = new Map();
  document.querySelectorAll('[data-product-json]').forEach(node => {
    try { const p = JSON.parse(node.textContent); if (p.id) products.set(String(p.id), p); } catch { }
  });
  const dialogs = [...document.querySelectorAll('dialog')];
  let focusReturn;
  function setTriggerState(dialog, expanded) {
    document.querySelectorAll('[data-open]').forEach(trigger => {
      if (trigger.dataset.open === dialog.id) trigger.setAttribute('aria-expanded', String(expanded));
    });
  }
  function close(dialog) {
    dialog.close();
    setTriggerState(dialog, false);
    if (!dialogs.some(d => d.open)) document.body.classList.remove('overlay-open');
    focusReturn?.focus();
  }
  function open(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    dialogs.filter(d => d.open).forEach(d => d.close());
    focusReturn = trigger || document.activeElement;
    if (header) document.documentElement.style.setProperty('--overlay-top', header.getBoundingClientRect().bottom + 'px');
    dialog.showModal();
    setTriggerState(dialog, true);
    document.body.classList.add('overlay-open');
    dialog.querySelector('input,button,a')?.focus();
  }
  dialogs.forEach(dialog => {
    dialog.addEventListener('close', () => { if (!dialog.open) setTriggerState(dialog, false); });
    dialog.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => close(dialog)));
    dialog.addEventListener('cancel', () => { setTriggerState(dialog, false); document.body.classList.remove('overlay-open'); focusReturn?.focus(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const b = dialog.getBoundingClientRect(); if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) close(dialog); } });
  });
  document.querySelectorAll('[data-open]').forEach(button => button.addEventListener('click', async () => {
    if (button.dataset.open === 'CartDrawer') { await loadCart(); }
    open(button.dataset.open, button);
  }));
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => header?.classList.toggle('is-scrolled', window.scrollY > 40), { passive: true });
  function announcement(message) {
    const live = document.getElementById('StoreStatus');
    if (live) live.textContent = message;
  }
  function productImage(img, source, alt) {
    if (!img || !source) return;
    img.removeAttribute('srcset');
    img.src = source;
    img.alt = alt || '';
  }
  async function request(path, data) {
    const response = await fetch(root + path, { method: data ? 'POST' : 'GET', credentials: 'same-origin', headers: data ? {'Content-Type':'application/json', Accept:'application/json'} : {Accept:'application/json'}, ...(data ? {body:JSON.stringify(data)} : {}) });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || text.error || 'Please try again.');
    return result;
  }
  function cartRow(item) {
    return `<article class="cart-item"><a href="${escape(item.url)}"><img src="${escape(item.image || '')}" alt="${escape(item.product_title)}" width="108" height="135"></a><div><h3><a href="${escape(item.url)}">${escape(item.product_title)}</a></h3><p>${escape(item.variant_title === 'Default Title' ? '' : item.variant_title)}</p><p>${money(item.final_line_price)}</p><div class="cart-item-actions"><div class="qty"><button type="button" data-cart-key="${escape(item.key)}" data-cart-qty="${Math.max(0,item.quantity-1)}" aria-label="${escape(text.decrease)}">−</button><span>${item.quantity}</span><button type="button" data-cart-key="${escape(item.key)}" data-cart-qty="${item.quantity+1}" aria-label="${escape(text.increase)}">+</button></div><button type="button" class="remove-item" data-cart-key="${escape(item.key)}" data-cart-qty="0">${escape(text.remove)}</button></div></div></article>`;
  }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count || ''; });
    document.querySelectorAll('[data-cart-items]').forEach(node => {
      node.innerHTML = cart.items?.length ? cart.items.map(cartRow).join('') : `<div class="empty-cart"><h3>${escape(text.empty_cart)}</h3><a class="pill" href="${root}collections/all">${escape(text.continue_shopping)}</a></div>`;
    });
    document.querySelectorAll('[data-cart-total]').forEach(node => { node.textContent = money(cart.total_price); });
    document.querySelectorAll('[data-cart-summary]').forEach(node => { node.hidden = !cart.items?.length; });
    document.querySelectorAll('[data-cart-recommendations]').forEach(node => { node.hidden = !!cart.items?.length; });
    document.querySelectorAll('[data-cart-key]').forEach(button => button.addEventListener('click', async () => {
      button.disabled = true;
      try { const key = button.dataset.cartKey; const qty = Number(button.dataset.cartQty); const container = button.closest('[data-cart-items]'); const delta = qty - Number(button.closest('.cart-item').querySelector('.qty span')?.textContent); const index = [...container.querySelectorAll('.cart-item')].indexOf(button.closest('.cart-item')); const updated = await request('cart/change.js', {id:key,quantity:qty}); renderCart(updated); const candidate = [...container.querySelectorAll('[data-cart-key]')].find(node => node.dataset.cartKey === key && Number(node.dataset.cartQty) === Math.max(0, qty + delta)); const fallback = container.querySelectorAll('.cart-item')[index]?.querySelector('a') || container.querySelector('.cart-item:last-child a') || container.querySelector('a'); (candidate || fallback)?.focus(); announcement(text.cart_updated); }
      catch (error) { announcement(error.message); button.disabled = false; const message=document.querySelector('[data-cart-error]'); if(message)message.textContent=error.message; }
    }));
  }
  async function loadCart() {
    try { const cart = await request('cart.js'); renderCart(cart); }
    catch (error) { announcement(error.message); const message=document.querySelector('[data-cart-error]'); if(message)message.textContent=error.message; }
  }
  async function add(id, quantity, button, errorNode) {
    button.disabled = true;
    if (errorNode) errorNode.textContent = '';
    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');
    const originalLabel = button.textContent;
    button.textContent = text.adding || originalLabel;
    try { await request('cart/add.js', {items:[{id:Number(id),quantity:Number(quantity)||1}]}); await loadCart(); open('CartDrawer', button); announcement(text.added); }
    catch (error) { if (errorNode) errorNode.textContent = error.message; announcement(error.message); }
    finally { delete button.dataset.busy; button.removeAttribute('aria-busy'); button.textContent = originalLabel; button.disabled = button.dataset.selectionDisabled === 'true'; }
  }
  document.querySelectorAll('[data-quick-add]').forEach(button => button.addEventListener('click', () => {
    const product = products.get(button.dataset.quickAdd);
    if (!product) return;
    const panel = document.getElementById('QuickBody');
    const title = button.dataset.title || product.title;
    const selected = product.variants.find(v => v.available) || product.variants[0];
    panel.innerHTML = `<img src="${escape(selected?.featured_image?.src || product.featured_image || product.images?.[0] || '')}" alt="${escape(title)}" width="350" height="440"><div><h3>${escape(title)}</h3><p data-quick-price>${money(selected?.price || product.price)}</p><label for="QuickVariant">${escape(text.choose_variant)}</label><select class="variant-select" id="QuickVariant">${product.variants.map(v=>`<option value="${v.id}" ${v.available?'':'disabled'} ${v.id===selected?.id?'selected':''}>${escape(v.title)}${v.available?'':` — ${escape(text.sold_out)}`}</option>`).join('')}</select><button class="pill black" type="button" data-quick-submit>${escape(text.add_to_basket)}</button><p class="error-message" data-quick-error role="alert"></p><a class="text-link" href="${root}products/${escape(product.handle)}">${escape(text.view_details)}</a></div>`;
    const select=panel.querySelector('select');
    const submit=panel.querySelector('[data-quick-submit]');
    submit.dataset.selectionDisabled=String(!product.variants.some(v=>v.available));submit.disabled=submit.dataset.selectionDisabled==='true';
    select.addEventListener('change',()=>{const v=product.variants.find(v=>String(v.id)===select.value);if(!v)return;panel.querySelector('[data-quick-price]').textContent=money(v.price);productImage(panel.querySelector('img'),v.featured_image?.src,v.title);submit.dataset.selectionDisabled=String(!v.available);submit.disabled=!v.available||submit.dataset.busy==='true';});
    submit.addEventListener('click',()=>add(select.value,1,submit,panel.querySelector('[data-quick-error]')));
    open('QuickDialog',button);
  }));
  document.querySelectorAll('[data-quantity]').forEach(control => {
    const input=control.querySelector('input');
    control.querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>{input.value=String(Math.max(1,Math.min(99,Number(input.value)+(Number(button.dataset.step)||0))));}));
  });
  const thumbnails = [...document.querySelectorAll('[data-thumbnail]')];
  const mainImage = document.querySelector('[data-main-image]');
  function revealThumbnail(button) {
    if (!button) return;
    const strip = button.parentElement;
    strip.scrollTo({left: strip.scrollLeft + button.getBoundingClientRect().left - strip.getBoundingClientRect().left - (strip.clientWidth - button.clientWidth) / 2, behavior: 'instant'});
  }
  function selectImage(button) {
    if (!button || !mainImage) return;
    const source = new URL(button.dataset.thumbnail, location.href);
    if (new URL(mainImage.src, location.href).pathname !== source.pathname) {
      mainImage.srcset = [400, 600, 900, 1200, 1800].map(width => { const url = new URL(source); url.searchParams.set('width', width); return url.href + ' ' + width + 'w'; }).join(', ');
      mainImage.src = source.href;
    }
    mainImage.alt = button.dataset.imageAlt || '';
    revealThumbnail(button);
    thumbnails.forEach(node => node.setAttribute('aria-current', String(node === button)));
    const count = document.querySelector('[data-gallery-count]');
    if (count) count.textContent = (text.image_count || '{{ current }} / {{ total }}').replace('{{ current }}', String(thumbnails.indexOf(button) + 1)).replace('{{ total }}', String(thumbnails.length));
  }
  thumbnails.forEach((button, index) => {
    button.addEventListener('click', () => selectImage(button));
    button.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? thumbnails.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbnails.length) % thumbnails.length;
      thumbnails[next].focus();
      selectImage(thumbnails[next]);
    });
  });
  selectImage(thumbnails.find(button => button.getAttribute('aria-current') === 'true') || thumbnails[0]);
  let galleryResizeFrame;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(galleryResizeFrame);
    galleryResizeFrame = requestAnimationFrame(() => revealThumbnail(thumbnails.find(button => button.getAttribute('aria-current') === 'true')));
  }, {passive:true});
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const product = products.get(form.dataset.productForm);
    if (!product) return;
    const section = form.closest('[data-product-section]');
    const select = form.querySelector('[data-variant-select]');
    const submit = form.querySelector('[type=submit]');
    if (!select || !submit) return;
    const fields = [...form.querySelectorAll('[data-option-position]')];
    const enhanced = form.querySelector('[data-enhanced-options]');
    if (enhanced) { enhanced.hidden = false; form.querySelector('[data-native-variant]').hidden = true; }
    const update = (replaceURL = true) => {
      const values = fields.map(field => field.querySelector('input:checked')?.value);
      const variant = fields.length ? product.variants.find(v => v.options.every((value, i) => value === values[i])) : product.variants.find(v => String(v.id) === select.value);
      const label = variant ? (variant.available ? text.add_to_basket : text.sold_out) : text.unavailable;
      submit.dataset.selectionDisabled = String(!variant?.available);
      submit.disabled = !variant?.available || submit.dataset.busy === 'true';
      if (!submit.dataset.busy) submit.textContent = label;
      select.value = variant ? String(variant.id) : '';
      const price = section?.querySelector('[data-product-price]');
      if (price) { price.hidden = !variant; if (variant) price.textContent = money(variant.price); }
      const note = form.querySelector('[data-selection-note]');
      if (note) note.textContent = !variant ? text.unavailable_help : !variant.available ? text.sold_out_help : variant.title === 'Default Title' ? '' : variant.title;
      fields.forEach((field, optionIndex) => field.querySelectorAll('input').forEach(input => {
        const candidates = product.variants.filter(v => v.options.every((value, i) => i === optionIndex ? value === input.value : value === values[i]));
        const state = !candidates.length ? 'unavailable' : candidates.some(v => v.available) ? 'available' : 'sold-out';
        input.closest('label').dataset.availability = state;
        input.title = state === 'unavailable' ? text.unavailable : state === 'sold-out' ? text.sold_out : '';
      }));
      if (variant?.featured_image) {
        const matched = thumbnails.find(button => String(button.dataset.imageId) === String(variant.featured_image.id)) || thumbnails.find(button => new URL(button.dataset.thumbnail, location.href).pathname === new URL(variant.featured_image.src, location.href).pathname);
        if (matched) selectImage(matched);
      }
      if (replaceURL) { const url = new URL(location.href); if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant'); history.replaceState({}, '', url); }
    };
    form.querySelectorAll('input[type=radio]').forEach(input => input.addEventListener('change', () => update()));
    select.addEventListener('change', () => update());
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || submit.disabled || !select.value) return;
      await add(select.value, form.querySelector('[name=quantity]').value, submit, form.querySelector('[data-product-error]'));
      update(false);
    });
    update(false);
  });
  document.querySelectorAll('[data-size-link], [data-details-link]').forEach(link => link.addEventListener('click', event => {
    const details = document.getElementById(link.hash.slice(1));
    if (!details) return;
    event.preventDefault(); details.open = true;
    const table = link.hasAttribute('data-size-link') ? details.querySelector('.description-table') : null;
    const target = table || details.querySelector('summary');
    target.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  }));
  document.querySelectorAll('.product-description table').forEach(table => {
    const wrapper = document.createElement('div');
    const hint = document.createElement('p'); hint.className = 'size-scroll-hint'; hint.textContent = text.measurement_scroll; table.before(hint);
    wrapper.className = 'description-table'; wrapper.tabIndex = 0; wrapper.setAttribute('role', 'region'); wrapper.setAttribute('aria-label', text.measurement_scroll);
    table.before(wrapper); wrapper.append(table);
    const rows = [...table.rows];
    rows.forEach((row, i) => [...row.cells].forEach((cell, j) => {
      if (cell.tagName === 'TH' || !(i === 0 || j === 0)) return;
      const heading = document.createElement('th'); heading.innerHTML = cell.innerHTML; heading.colSpan = cell.colSpan; heading.rowSpan = cell.rowSpan; heading.scope = i === 0 ? 'col' : 'row'; cell.replaceWith(heading);
    }));
  });
  const zoom = document.querySelector('[data-zoom]');
  zoom?.addEventListener('click', () => { const source = document.querySelector('[data-main-image]'); const img = document.querySelector('#ZoomDialog img'); if (!source || !img) return; img.src = source.src; img.alt = source.alt; open('ZoomDialog', zoom); });
  const searchInput=document.querySelector('[data-search-input]');
  let searchTimer, searchAbort;
  searchInput?.addEventListener('input',()=>{
    clearTimeout(searchTimer);searchAbort?.abort();
    const results=document.querySelector('[data-search-results]');
    if(searchInput.value.trim().length<2){results.innerHTML='';return;}
    searchTimer=setTimeout(async()=>{
      searchAbort=new AbortController();
      try{
        const query=new URLSearchParams({q:searchInput.value,'resources[type]':'product','resources[limit]':'8'});
        const response=await fetch(root+'search/suggest.json?'+query,{signal:searchAbort.signal});
        if(!response.ok)throw new Error(text.error);
        const result=await response.json();const found=result.resources?.results?.products||[];
        results.innerHTML=found.length?found.map(p=>`<article class="product-card"><a class="card-media" href="${escape(p.url)}"><img src="${escape(p.featured_image?.url||p.image||'')}" alt="${escape(p.title)}" width="300" height="300"></a><div class="card-meta"><h3><a href="${escape(p.url)}">${escape(p.title)}</a></h3></div></article>`).join(''):`<p>${escape(text.no_results)}</p>`;
      }catch(error){if(error.name!=='AbortError')results.textContent=text.error;}
    },220);
  });
  document.querySelector('[data-sort]')?.addEventListener('change',event=>{const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);location.href=url;});
  const filterDisclosure=document.querySelector('.collection-filter-disclosure');
  if(filterDisclosure){const phone=window.matchMedia('(max-width:767px)');const setFilterState=()=>{filterDisclosure.open=!phone.matches;};setFilterState();phone.addEventListener('change',setFilterState);}
  if(document.querySelector('.cart-page'))loadCart();
})();
